import {
  CustomButton,
  CustomLabel,
  FlexContainer,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";
import { MainOuterCard } from "../../../shared/styles";

export const MerchantWrapper = styled.div`
  /* padding: 50px; */
  ${CustomLabel} {
    display: block;
    line-height: normal;
    &.merchant-header {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 30px;
    }
    &.merchant-header-description {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 10px;
    }
    &.merchant-subheader {
      font-weight: 600;
      line-height: 20px;
      margin: 0px 0px 20px;
    }
  }
  ${MainOuterCard} {
    padding: 50px;
  }
  .option-category-select {
    width: 300px;
  }
  .desc-merchant-form {
    width: 225px;
  }
  .mindme-payment-icon {
    height: 90px;
    width: 200px;
    display: inline-block;
  }
  .merchant-inputs {
    width: 400px;
    border: 1px solid #ccc;
  }
  .select-overflowed-ellipsis {
    .select-header-span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }
  }
`;

export const MerchantBlocks = styled.div`
  margin-top: 40px;
  &.rows-margin-bottom {
    > ${FlexContainer}:not(.no-margin-bottom) {
      margin-bottom: 20px;
    }
    .no-margin-bottom {
      div {
        &:first-child {
          width: 400px;
        }
        &:last-child {
        }
      }
    }
    .volume-and-location > div {
      &:first-child {
        width: 400px;
        .merchant-inputs {
          width: 400px;
        }
      }
      &:last-child {
        .merchant-inputs {
          width: 100px;
        }
      }
    }
    > div,
    > input {
      margin-bottom: 20px;
    }
    .single-select-wrapper {
      width: 400px;
      .header {
        width: 400px;
        border: 1px solid #ccc;
      }
    }
  }
  .option-select__value-container {
    padding: 4px 8px;
  }
  .country-phone-dpdn > div {
    width: 400px;
  }
  .country-phone-dpdn .input-wrapper {
    width: 400px;
  }
  .error-message {
    font-size: 11px;
  }
  .payment-method-select {
    width: 450px;
    margin-left: 2px;
    .payment-method__control {
      border-color: #aaa;
      box-shadow: none;
      &:focus,
      &:hover {
        outline: none;
        border-color: #aaa;
        box-shadow: none;
      }
    }
    .payment-method__menu-list {
      max-height: 130px !important;
      overflow-y: auto !important;
    }
    &.nmi-payment-method-select {
      width: 400px;
    }
  }
  .country-origin-dpdn {
    .country-phone-wrapper {
      width: auto;
    }
    .nmi-country-dropdown {
      width: 400px;
      height: 40px;
    }
  }
  /* Searchable dropdowns (e.g. State): keep the option text and the search box
     text aligned at the same left inset. The shared package forces the search
     input's padding to 0 with !important, so the override below needs matching
     specificity + !important to actually take effect. */
  .single-select-wrapper .options-menu.dpdn-with-search {
    /* Keep the outer menu from scrolling horizontally. */
    overflow-x: hidden;
    .dropdown-option-list {
      /* The package sets only overflow-y: auto, so the browser promotes
         overflow-x to auto too; combined with the left padding this produced a
         second (horizontal) scrollbar. Include the padding in the width and
         hide horizontal overflow so only the vertical scrollbar remains. */
      box-sizing: border-box;
      overflow-x: hidden;
      padding-left: 12px;
      /* Match the Country dropdown scrollbar: light gray track behind a darker
         thumb (the package default has these reversed). */
      &::-webkit-scrollbar {
        width: 0.4em;
        height: 0.4em;
        background-color: rgb(232, 234, 235);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
    }
    .input-wrapper .searchable-dropdown-input {
      padding-left: 12px !important;
    }
  }
`;

export const MerchantCard = styled.div<{ $fill?: boolean }>`
  background-color: #fff;
  padding: 15px 25px 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 0px;
  box-sizing: border-box;
  /* 1-2 accounts: fixed 500px, no grow, so they sit left-aligned without
     stretching. 3+ accounts ($fill): let cards grow to fill the row so there
     aren't large empty gutters on the sides. Capped so a lone card on the last
     row doesn't balloon. On small screens cards go full-width. */
  flex: ${(props) => (props.$fill ? "1 1 460px" : "0 1 500px")};
  min-width: ${(props) => (props.$fill ? "440px" : "300px")};
  max-width: ${(props) => (props.$fill ? "620px" : "500px")};
  min-height: 275px;
  height: auto;
  @media (max-width: 600px) {
    min-width: 0;
    flex-basis: 100%;
    max-width: 100%;
  }
  button {
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    /* Center the label and keep it on one line so it can't spill out of the
       fixed-height buttons (e.g. "Cancel Application" at 75% zoom / narrow cards). */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: normal;
    white-space: nowrap;
  }
  ${CustomButton} {
    height: 30px;
    min-width: 100px;
    width: 100px;
    border-radius: 6px;
  }
  .merchant-card-header {
    justify-content: space-between;
    align-items: center;
    padding: 0 0 20px 0;
    > div {
      min-width: 100px;
      &:last-child {
        text-align: right;
      }
    }
    img {
      width: 100px;
      height: 60px;
      object-fit: contain;
      &.tsys-logo {
        width: 80px;
      }
      &.elavon-logo {
      }
      &.global-collect-logo {
        /* The Global Payments lockup is a very wide horizontal mark
           (viewBox 1800x276, ~6.5:1). Inside the shared 100x60 box,
           object-fit: contain fits it by width, so it rendered at only
           ~100x15px and the wordmark was unreadable. Widen the box (the 60px
           height is kept so every card header stays the same height) and let
           contain centre the mark vertically at ~160x25px, which matches the
           cap height of the other processor logos.
           min-width: 0 opts out of the flex automatic minimum size so the
           logo scales down proportionally on very narrow cards instead of
           overflowing the header. */
        width: 160px;
        min-width: 0;
      }
      &.fiserv-logo {
        height: auto;
      }
      &.mindme-logo {
      }
    }
  }
  .merchant-card-descr {
    width: 100%;
    max-width: 340px;
    /* Balance the wrapped lines so short copy (e.g. NMI text) doesn't leave
       one or two orphan words on the last line. */
    text-wrap: balance;
  }
  .ellipsis-vertical {
    img {
      height: 20px;
      width: 5px;
      cursor: pointer;
    }
    &::after {
      display: none;
    }
  }
  .merchant-status-button {
    .dropdown-menu {
      font-size: 14px;
      line-height: 18px;
      a {
        color: #555;
        &:active {
          background-color: #ededee;
        }
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
`;
